import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import logo  from '../../Assets/logo.png'
const  Footer = () => {
  return (
    <footer className="bg-[#00adef] text-white py-10">
      <div className="container max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
        {/* About Section */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Kalamji Academy</h2>
          <ul className="space-y-2 text-sm">

            <li className="hover:underline flex items-center">
              An Institute of Coaching <br /> and Teaching for Achievers.
            </li>

            <li className="hover:underline flex items-center"> 
              <FaEnvelope className="mr-2" /> kalamjiacademy@gmail.com
            </li>

            <li className="hover:underline flex items-center">
              <FaPhoneAlt className="mr-2" /> +91 94 88 44 00 66 <br /> +91 99 94 55 8487
            </li>

            <li className="hover:underline flex items-center">
              <FaMapMarkerAlt className="mr-2" /> #23, New Shankaranpalyam Road, <br />  Tollgate,Vellore-632001
            </li>
          </ul>
        </div>
        {/* Quick Links */}   
        <div>
          <h2 className="text-2xl font-bold mb-4">Quick Links</h2>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/about" className="hover:underline">About</a>
            </li>
            <li>
              <a href="/courses" className="hover:underline">Courses</a>
            </li>
            <li>6
              <a href="/contact" className="hover:underline">Contact</a>
            </li>
            <li>
              <a href="/faq" className="hover:underline">FAQ</a>
            </li>
          </ul>
        </div>
        {/* Social Media */} 
        <div> 
          <h2 className="text-2xl font-bold mb-4">Follow Us</h2>
          <div className="flex space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">
              <FaFacebookF size={24} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com322" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">
              <FaLinkedinIn size={24} />
            </a>
          </div>
        </div>  
        
      </div>  
      {/* Footer Bottom */}
      <div className="mt-8 border-t border-gray-200 text-center text-sm flex items-center justify-center">
        <img src={logo} alt="logo" className=" w-36 h-36  mr-4 object-cover"  />
        <p>&copy; {new Date().getFullYear()} Kalamji Academy. All rights reserved.</p>
        {
        /* { new Date().test('should first', () => { second })
        const test =>(){
      test-ast
        }} */}

      </div>
    </footer>
  );
};

export default Footer;
